<template>
  <div class="content-tab port-config">
    <div class="content-body">
      <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="title">{{$t('interfaceTitle')}}</div>
        <div class="group-table" v-if="ports.length > 0">
          <fixed-table ref="portTable" :data="ports" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width:10%;">{{$t('port.portnumber')}}</column>
              <column :style="{ width: isFec ? '20%' : '20%' }">{{$t('port.state')}}</column>
              <column :style="{ width: isFec ? '25%' : '35%' }">{{$t('port.speed')}}
                <span ref="infoTips" class="icon-info info-color ft-14 tempInfo" @click="onInfoClick($event, 'speed')"></span>
              </column>
              <column v-if='isFec' style="width:25%;">{{$t('port.fec')}}
                <span ref="infoTips" class="icon-info info-color ft-14 tempInfo" @click="onInfoClick($event, 'fec')"></span>
              </column>
              <column :style="{ width: isFec ? '20%' : '35%' }">{{$t('port.flowcontrol')}}</column>
            </div>
            <template slot="rows" slot-scope="props" v-if="Number(props.data.key) <= portNumber">
              <div class="link-row">
                <row class="right" :props="props">
                  <div class="data" style="width:10%;">{{props.data.key}}</div>
                  <div class="data" :style="{ width: isFec ? '20%' : '20%' }" >
                    <toggle :on="!props.data.val.Shutdown" @click.native="onSwitchBtn(props, 'Shutdown')" :disabled="getDisabled(props.data.key)"></toggle>
                  </div>
                  <div class="data speed" :style="{ width: isFec ? '25%' : '35%' }">
                    <q-select class="q-select" :props="props.index" :value="props.data.val.Speed" :options-array="getSpeedSelection(props.data.key)" :rule="props.data.key" @change="onMenuChange" :class="{'disabled': getDisabled(props.data.key) || getSfpDisabled(props.data.key)}" :isDisabled="getDisabled(props.data.key) || getSfpDisabled(props.data.key)" :title="getLagTips(props.data.key)"></q-select>
                  </div>
                  <div class="data" v-if='isFec' style="width:25%;">
                    <q-select class="q-select" :props="props.index" :value="getFecModeValue(props.data.val.FEC)" :options-array="FecMode" :rule="props.data.key" :title="setTitle(props.data.val.FEC, props.data.key)" @change="onFecChange" :class="{'disabled': props.data.val.FEC === 'N/A' }" :isDisabled="props.data.val.FEC === 'N/A' || getDisabled(props.data.key)"></q-select>
                  </div>
                  <div class="data" :style="{ width: isFec ? '20%' : '35%' }">
                    <toggle :title="getTips(props.data.val.Speed)" :on="props.data.val.FC" @click.native="onSwitchBtn(props, 'FC')" :disabled="getFCdisabled(props.data.val, props) || getDisabled(props.data.key)" ></toggle>
                  </div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
        <div class="title">{{$t('lagTitle')}} {{$t('port.lagInfo')}}</div>
        <div class="group-table" v-if="ports.length > 0">
          <fixed-table ref="portTable" :data="ports" :use-page="false" :header-height="40">
            <div class="right-header" slot="right-header">
              <column style="width:10%;">{{$t('group')}}</column>
              <column style="width:90%;">{{$t('port.state')}}</column>
            </div>
            <template slot="rows" slot-scope="props" v-if="props.data.key > lagStartNum && props.data.key <= lagStartNum + lagGroupMap.size">
              <div class="link-row">
                <row class="right" :props="props">
                  <div class="data" style="width:10%;">{{getLagName(props.data.key)}}</div>
                  <div class="data" style="width:90%;">
                    <toggle :on="!props.data.val.Shutdown" @click.native="onSwitchBtn(props, 'Shutdown')"></toggle>
                  </div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
    <popup-confirm name="fec-warning-modal" :dialog-header="$t('warning')" :dialog-message="$t('port.fecLimit')" :onlyOk="true" icon="w" />
  </div>
</template>

<script>
import config from '../config'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import toggle from './module/Toggle'
import qSelect from './module/Select.vue'
import {
  mapActions,
  mapState,
  mapMutations
} from 'vuex'
export default {
  name: 'PortConfigure',
  components: {
    fixedTable,
    row,
    column,
    toggle,
    qSelect
  },
  data () {
    return {
      portSpeed: config.constant.PortSpeed,
      tenSpeed: config.constant.TenGspeed,
      twoG5Speed: config.constant.TwoG5Speed,
      FecMode: config.constant.FecMode,
      ports: {},
      lagPorts: {},
      columns: ['portnumber', 'link', 'state', 'speed', 'flowcontrol'],
      options: {
        headings: {
          portnumber: 'Port Number',
          link: 'Link',
          state: 'State',
          speed: 'Speed',
          flowcontrol: 'Flow Control'
        },
        maxSize: [
          {value: '1518', label: '1518'},
          {value: '4092', label: '4092'},
          {value: '7436', label: '7436'},
          {value: '9018', label: '9018'}
        ]
      },
      toggleList: [],
      selectType: false,
      isButtonEnable: false,
      originalData: null,
      isShowLoading: false,
      isAllSame: true
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  created: async function () {
  },
  watch: {
    isButtonEnable: function (value) {
      if (!value) {
        this.$store.commit('updateDataChanged', false)
      } else {
        this.$store.commit('updateDataChanged', true)
      }
    },
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          this.getData()
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    getData: async function () {
      this.isShowLoading = true
      this.isButtonEnable = false
      this.getPortConfigure()
        .then(res => {
          if (res.data.error_code === 200) {
            let data = (res.data)
            let detail = data.result
            let tempArray = detail
            tempArray.forEach((element, index) => {
              if (element.val.AutoMode) {
                tempArray[index].val.Speed = 'autoNegMode'
              }
            })
            tempArray = this.switchSpeedValue('set', tempArray)
            this.ports = tempArray
            this.isShowLoading = false
            this.originalData = JSON.parse(JSON.stringify(this.ports))
            this.$log.debug(this.ports)
          } else {
            this.$log.debug(res.data)
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    getLagName: function (key) {
      return this.$t('lag.groupName') + ' ' + (Number(key) - this.lagStartNum)
    },
    onMenuChange: function (value, index) {
      this.ports[index].val.Speed = value
      if (value !== 'autoNegMode') {
        this.ports[index].val.AutoMode = false
      } else {
        this.ports[index].val.AutoMode = true
      }
      this.checkValidation()
    },
    onFecChange: function (value, index) {
      this.ports[index].val.FEC = value
      this.checkValidation()
    },
    switchSpeedValue: function (type, data) {
      let tempData = data
      if (type === 'get') { // get fdx, hdx
        tempData.forEach((element, idx) => {
          if (Number(element.key) <= this.portNumber) {
            let tempArray = element.val.Speed.split('_')
            if (element.val.Speed !== 'autoNegMode') {
              tempData[idx].val.Speed = tempArray[0]
              tempData[idx].val.Fdx = (tempArray[1] === 'fdx')
            }
          }
        })
      } else if (type === 'set') { // set fdx, hdx
        tempData.forEach((element, idx) => {
          if (Number(element.key) <= this.portNumber) {
            if (!element.val.AutoMode) {
              let type = (element.val.Fdx || (element.val.Speed !== 'tenMBPS' && element.val.Speed !== 'hundredMBPS')) ? '_fdx' : '_hdx'
              tempData[idx].val.Speed = element.val.Speed + type
            }
          }
        })
      }
      return tempData
    },
    getFCdisabled: function (data, key) {
      let result = false
      if (data.Speed.includes('hdx')) {
        this.ports[key.index].val.FC = false
        result = true
      }
      return result
    },
    getSpeedSelection: function (port) {
      var result
      if (this.sysBoard && this.sysBoard.Product.includes('M408')) {
        result = parseInt(port) < 9 ? this.portSpeed : this.tenSpeed
      } else if (this.sysBoard && this.sysBoard.Product.includes('M2108')) {
        result = parseInt(port) < 9 ? this.twoG5Speed : this.tenSpeed
      } else if (this.sysBoard && this.sysBoard.Product.includes('M2106')) {
        result = parseInt(port) < 7 ? this.twoG5Speed : this.tenSpeed
      } else {
        result = this.tenSpeed
      }
      return result
    },
    checkChangedItem: function () {
      let data = []
      this.ports.forEach((element, index) => {
        if (element.val.Shutdown !== this.originalData[index].val.Shutdown) {
          data.push(element)
        } else if (element.val.Speed !== this.originalData[index].val.Speed && element.val.Speed !== this.originalData[index].val.Speed.split('_')[0]) {
          data.push(element)
        } else if (element.val.Fdx !== this.originalData[index].val.Fdx) {
          data.push(element)
        } else if (element.val.FC !== this.originalData[index].val.FC) {
          data.push(element)
        } else if (element.val.FEC !== this.originalData[index].val.FEC) {
          data.push(element)
        }
      })
      return data
    },
    onSaveClick: function () {
      let countFec = 0
      let self = this
      let changedItem = this.checkChangedItem()
      let tempData = null
      this.isShowLoading = true
      let setArr = []
      tempData = this.switchSpeedValue('get', changedItem)
      tempData.forEach((item, index) => {
        item.val.AutoMode = (item.val.Speed === 'autoNegMode')
        setArr.push({'idx': item.key, 'data': item.val})
      })
      this.ports.forEach(element => {
        if (element.val.FEC === 'auto' || element.val.FEC === 'RS_FEC' || element.val.FEC === 'FC_FEC') countFec++
      })
      if (countFec < 99 || !this.systemHostInfo.Product.includes('M5216-1T')) { // 0520 Fec can more than 14 ports
        this.$store.commit('updateGetDeviceData', false)
        this.postPortConfigure(JSON.stringify(setArr))
          .then(async result => {
            await self.getData()
            if (!this.deviceCollapsed) this.$store.commit('updateGetDeviceData', true)
          })
          .catch(error => {
            this.isShowLoading = false
            if (!this.deviceCollapsed) this.$store.commit('updateGetDeviceData', true)
            this.$log.error(error)
            this.$store.commit('setErrorWin', {
              show: true,
              data: {'error_code': 1},
              config: 'snmp_error',
              title: null
            })
          })
      } else {
        this.isShowLoading = false
        this.$modal.show('fec-warning-modal')
      }
    },
    onSwitchBtn: function (props, type) {
      let result = this.ports[props.index]
      if (type !== 'FC') {
        result.val[type] = !result.val[type]
      } else {
        result.val[type] = (this.getFCdisabled(result.val)) ? result.val[type] : !result.val[type]
      }
      this.$forceUpdate()
      this.checkValidation()
    },
    checkValidation (fieldName) {
      if (!this.$compareObj(this.ports, this.originalData)) {
        this.isButtonEnable = true
      } else {
        this.isButtonEnable = false
      }
    },
    onHelpClick: function () {
      this.$store.commit('updateQuickHelp', !this.showQuickHelp)
    },
    getTips: function (speed) {
      let result = ''
      if (speed.includes('_hdx')) {
        result = this.$t('port.hdxTips')
      }
      return result
    },
    getSfpDisabled: function (port) {
      let key = Number(port)
      if (this.onlySFPlist.includes(key)) {
        return true
      } else {
        return false
      }
    },
    getDisabled: function (port) {
      if (this.portMap.get(Number(port))) {
        return true
      } else {
        return false
      }
    },
    getLagTips: function (key) {
      let num = Number(key)
      let tips = ''
      if (this.getSfpDisabled(num)) {
        tips = this.$t('port.speedSfpInfo')
      }
      if (this.getDisabled(num)) {
        tips = this.$t('lag.alreadyJoin')
      }
      return tips
    },
    setTitle: function (fec, key) {
      if (this.isFec && fec === 'N/A') return this.$t('port.fecTip')
      if (this.getDisabled(Number(key))) return this.$t('lag.alreadyJoin')
      return ''
    },
    onInfoClick: function (event, type) {
      let message = (type === 'speed') ? [{text: this.$t('port.speedInfo')}] : [{text: this.$t('port.fecInfo')}]
      if (type !== 'speed') message.push({text: this.$t('port.fecInfoNote')})
      this.$store.commit('updateInfoTips', !this.showInfoTips)
      if (this.showInfoTips) {
        this.$store.commit('updateInfoData', {
          message: message,
          event: event
        })
      }
    },
    getFecModeValue (data) {
      if (data !== 'N/A') {
        return data
      } else {
        return 'none'
      }
    },
    ...mapActions(['getPortStatus', 'getPortConfigure', 'postPortConfigure', 'getFecConfigure', 'postLogout', 'updateGetDeviceData']),
    ...mapMutations([])
  },
  computed: {
    onlySFPlist: function () {
      return config.system.sfpPort[this.sysBoard.Product]
    },
    ...mapState({
      showInfoTips: state => state.app.showInfoTips,
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo,
      portNumber: state => state.module.portNum,
      currentUser: state => state.module.currentUser,
      showQuickHelp: state => state.app.showQuickHelp,
      isDataChanged: state => state.app.isDataChanged,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      lagStartNum: state => state.module.lagStartNum,
      systemHostInfo: state => state.module.systemHostInfo,
      deviceCollapsed: state => state.app.deviceCollapsed,
      isFec: state => state.module.isFec
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped deep>

.content-tab.port-config {
  position: relative;
  padding: 10px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .scrollbar-body {
    height: calc(100% - 40px);
  }
  .title {
    font-family: 'Roboto-M';
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 20px;
  }
  .group-table {
    margin: 0px 25px 20px 0px;
    .data-row {
      overflow: visible !important;
      .data {
        overflow: visible !important;
        .form-control {
          width: 200px;
          display: inline-block;
        }
      }
    }
  }
  .q-select .display-label {
    font-size: 13px;
    color: #000;
  }
  .q-select {
    width: 150px;
    height: 30px;
    border: 1px solid #979797 !important;
    border-radius: 4px;
    vertical-align: middle;
    /deep/ .dropdown-menu {
      left: -1px;
      width: 150px;
      height: auto;
      overflow: auto;
    }
    /deep/ .display-label {
      font-size: 13px !important;
      color: #2F2F2F !important;
      line-height: 30px !important;
    }
    &::after {
      background-color: #000;
      top: -25px;
    }
    &.disabled {
      cursor: not-allowed;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PortConfigure.vue